export const ACCESS_LEVELS = {
  PRIVATE: 'PRIVATE',
  EVERYONE: 'EVERYONE',
  EVERYONE_VIEW_ONLY: 'EVERYONE_VIEW_ONLY',
  EVERYONE_VIEW_AND_EDIT: 'EVERYONE_VIEW_AND_EDIT',
  SELECTED_USERS_AND_TEAMS: 'SELECTED_USERS_AND_TEAMS',
  SELECTED_TEAMS_VIEW_AND_EDIT: 'SELECTED_TEAMS_VIEW_AND_EDIT',
  SELECTED_USERS_AND_TEAMS_VIEW_ONLY: 'SELECTED_USERS_AND_TEAMS_VIEW_ONLY',
  SELECTED_USERS_AND_TEAMS_VIEW_AND_EDIT: 'SELECTED_USERS_AND_TEAMS_VIEW_AND_EDIT'
};